import type { ReactNode } from "react"

import { ChevronDown } from "@/components/icons"

import type { SavedDashboard } from "../services/dashboard-service"

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { cn } from "@/lib/utils"

type DashboardCollapsibleSectionProps = {
  label: string
  items: SavedDashboard[]
  isOpen: boolean
  isSearching: boolean
  setOpen: (open: boolean) => void
  renderItem: (d: SavedDashboard) => ReactNode
}

export function DashboardCollapsibleSection({
  label,
  items,
  isOpen,
  isSearching,
  setOpen,
  renderItem,
}: DashboardCollapsibleSectionProps) {
  if (items.length === 0) return null

  return (
    <Collapsible open={isOpen} onOpenChange={setOpen}>
      <section className="flex flex-col gap-1">
        <CollapsibleTrigger
          className="text-muted-foreground/70 hover:text-muted-foreground group/section flex w-full items-center gap-1 px-2 text-[10px] font-semibold tracking-wider uppercase disabled:cursor-default disabled:opacity-70"
          disabled={isSearching}
          type="button"
        >
          {label}
          <ChevronDown
            className={cn(
              "text-muted-foreground/70 group-hover/section:text-muted-foreground size-3.5 shrink-0 -translate-y-[2px] opacity-0 transition-transform duration-150 group-hover/section:opacity-100",
              !isOpen && "-rotate-90"
            )}
          />
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="flex flex-col">{items.map(renderItem)}</div>
        </CollapsibleContent>
      </section>
    </Collapsible>
  )
}
